/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiInAddress
 */
export interface PoiInAddress {
    /**
     * 
     * @type {string}
     * @memberof PoiInAddress
     */
    address: string;
}

export function PoiInAddressFromJSON(json: any): PoiInAddress {
    return PoiInAddressFromJSONTyped(json, false);
}

export function PoiInAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiInAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
    };
}

export function PoiInAddressToJSON(value?: PoiInAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
    };
}


